import styles from '@/views/blogger/resourcelibrary/style.module.less'
import DetailDisC from './DetailDisC'
import VTable from '@/vuetify_custom/v-table/v3'
import IsSampleTip from '@/vuetify_custom/IsSampleTip.vue'
import FansEchanrts from '@/views/blogger/resourcelibrary/components/FansEchanrts.jsx'
import { formattingNumber } from '@/libs/util.js'
import Effect from './Effect.jsx'
import {getPlacingAdsKolDetailApi} from '@/views/blogger/resourcelibrary/service.js'
export default {
    data() {
        return {
            detail: {}
        }
    },
computed: {
    table_fields() {
        return [
            {
                text: '投放编号',
                align: 'center',
                value: 'uid',
                width: 120,
             
                render:(v) => {
                    return <div>{v}</div>
                }
            }, 
          
            {
                text: 'SKU/项目组',
                align: 'center',
                value: 'sku',
                width: 120,
                render:(_, t) => <div>
                        <div>{t.sku && t.sku.sku_name || '-'}</div>
                        <div>{t.team_name || '-'}</div>
                    </div>
            },
            {
                text: '内容类别',
                align: 'center',
                value: 'boz',
                width: 100,
                render:(_, t) => <div>{t.tags || '-'}</div>
            },
         
            {
                text: '投放金额',
                type: 'money_field',
                align: 'left',
                value: 'leiji',
                width: 150,
                render: (_, target) => {
                   const res = math.eval(`${target.vas_amount || 0}+${target.payable_price || 0}+${target.addition_amount || 0}-${target.rebate_amount || 0}`)
                   return <div>
                       <div class={styles['dis-flex']}><span>预计投放金额：</span><span class={styles['flex-1']} style="text-align:right">{formattingNumber(target.total_price, 2)}</span></div>
                       <div class={styles['dis-flex']}><span>实际消耗：</span><span class={styles['flex-1']} style="text-align:right">{formattingNumber(target.payable_price, 2)}</span></div>
                       <div class={styles['dis-flex']}><span>累计金额：</span><span class={styles['flex-1']} style="text-align:right">{formattingNumber(res.toNumber(), 2)}</span></div>
                   </div>
                }
            },
            {
                text: '投放信息',
                align: 'center',
                value: 'placing_ads_url',
                width: 120,
                render: (_, target) => {
                    if (!target.placing_ads_url) {
                        return <div>-</div>
                    }
                    return <div>
                            <div>{target.publish_at}</div>
                            <a href={target.placing_ads_url} target="__blank">投放链接🔗</a>
                        </div>
                }
            },
        
            {
                text: '7天效果',
                align: 'left',
                value: 'first_week_effect',
                width: 100,
              //  fixed: 'right',
                z_index:2,
                render:(_, t) => {
                
                    return <Effect value={t} showList={[2]}/>
                }
            },
            {
                text: '评价',
                align: 'left',
                value: 'amount_effect',
                width: 260,
              //  fixed: 'right',
                z_index:2,
                render:(_, t) => {
                
                    return <Effect value={t} showList={[3]}/>
                }
            },
          
        ]
    }
},
    created() {
       
    }, 
    mounted() {
        let {query} = this.$route
        query = query || {}
    
        getPlacingAdsKolDetailApi({id:query.id}).then(res => {
            this.detail = res || {}
            this.$refs.fans.display(this.detail.fans_logs || [])
        })
    },
    render() {
        return <div>
            <div class={styles['detail-contain']}>
                <div class={`${styles['card-contain-d']}`}>
                    <div style="flex:1" class={styles['card-content']}>
                        <p class={styles['f-s']}>平台：{ this.detail.platform}</p>
                        <p class={styles['f-s']}>内容类别：{this.detail.tags}</p>
                        {!!this.detail.is_risk && <p class={styles['f-s']}>风险理由：{this.detail.risk_mark}</p>}
                        {/* <p><span>入库时间</span><span>{this.value.put_in_time}</p> */}
                    </div>
                    
                    <div style="flex:1" class={styles['card-content']}>
                        <p class={styles['f-s']}><span>粉丝数量 <IsSampleTip icon="mdi-clock-time-two-outline" content={`更新时间：${this.detail.fans_amount_updated_at}`}/>：</span><span class={styles.value}> {this.detail.fans_amount}</span> </p>
                        <p class={styles['f-s']}><span>入库时间：</span> <span class={styles.value}>{this.detail.put_in_time}</span> </p>
                
                    
                    </div>
                    <div style="flex:1" class={styles['card-content']}>
                        <p class={styles['f-s']}><span>对接人：</span><span class={styles.value}> {this.detail.docking_customer_name}</span> </p>
                        <p class={styles['f-s']}><span>项目组：</span> <span class={styles.value}>{this.detail.team}</span> </p>
                    </div>
                </div>
                <div class={styles['card-contain-d']}>
                    <div style="flex:1">
                        <DetailDisC title="累计投放次数" value={this.detail.placing_ads_count}/>
                    </div>
                    <div style="flex:1" >
                        <DetailDisC title="平均投放成本" value={this.detail.avg_placing_costs && formattingNumber(this.detail.avg_placing_costs, 2) || this.detail.avg_placing_costs}/>
                    </div>
                    <div style="flex:1" >
                        <DetailDisC title="7天平均点赞成本" value={this.detail.avg_like_costs}/>
                    </div>
                </div>
            </div>
            <div>
                <FansEchanrts ref="fans"/>
            </div>
            <VTable 
                class={styles['table']}
                headers={this.table_fields}
                desserts={this.detail.placing_ads_records}
            />
        </div>
    }
}